import {Button, DialogActions, DialogContent, DialogTitle, TextField, Alert, useMediaQuery, useTheme} from "@mui/material";
import {IntegrationDialog as Dialog, IntegrationProviderGrid} from "../IntegrationDesign";
import {SettingsDialogDescription} from "../../SettingsDialog";
import React, {useEffect, useState, useCallback} from "react";
import Spinner from "../../../spinner/Spinner";
import {sharedAffiliateNetworkService} from "../../../../service/sharedAffiliateNetworkService";

function ChooseRsocIntegration(props) {

    const theme = useTheme();
    const [loading, setLoading] = useState(true);
    const [requestError, setRequestError] = useState("");
    const [templates, setTemplates] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const integrations = ["System1", "Inuvo Prism", "Ask Media Group", "Ads.com", "Predicto", "Sedo", "AirFind", "ExplorAds", "Tonic", "Prices.com"];

    const [open, setOpen] = useState(true);

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleChange = event => {
        setSearchQuery(event.target.value);
    };

    const selectIntegration = (item) => {
        if (item?.name === "System1") {
            props.history.push({pathname: "/settings/integrations/rsoc-system1", state: {from: props.location}});
        }
        if (item?.name === "Ask Media Group") {
            props.history.push({pathname: "/settings/integrations/rsoc-amg", state: {from: props.location}});
        }
        if (item?.name === "Ads.com") {
            props.history.push({pathname: "/settings/integrations/rsoc-ads-com", state: {from: props.location}});
        }
        if (item?.name === "Predicto") {
            props.history.push({pathname: "/settings/integrations/rsoc-predicto", state: {from: props.location}});
        }
        if (item?.name === "AirFind") {
            props.history.push({pathname: "/settings/integrations/rsoc-airfind", state: {from: props.location}});
        }
        if (item?.name === "ExplorAds") {
            props.history.push({pathname: "/settings/integrations/rsoc-explorads", state: {from: props.location}});
        }
        if (item?.name === "Tonic") {
            props.history.push({pathname: "/settings/integrations/rsoc-tonic", state: {from: props.location}});
        }
        if (item?.name === "Sedo") {
            props.history.push({pathname: "/settings/integrations/rsoc-sedo", state: {from: props.location}});
        }
        if (item?.name === "Inuvo Prism") {
            props.history.push({pathname: "/settings/integrations/rsoc-inuvo-prism", state: {from: props.location}});
        }
        if (item?.name === "Prices.com") {
            props.history.push({pathname: "/settings/integrations/rsoc-prices", state: {from: props.location}});
        }
    };

    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        setOpen(false);
        props.history.push({pathname: "/settings/integrations", state: {from: props.location}});
    }, [props]);

    const filteredTemps = !searchQuery
        ? templates
        : templates?.filter(item =>
            item?.name?.toLowerCase().includes(searchQuery.toLocaleLowerCase())
        );

    useEffect(() => {
        async function fetchData() {
            setRequestError("");
            setLoading(true);
            await sharedAffiliateNetworkService.read().then((response) => {
                if (response !== null && response !== undefined) {
                    setTemplates(response?.sharedAffiliateNetworks);
                }
            }).catch((error) => {
                if (error?.response?.data?.error) {
                    setRequestError(error.response.data.error);
                }
            }).finally(() => {
                setLoading(false);
            });
        }

        if (templates === null) {
            fetchData();
        }
    }, [templates]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth fullScreen={fullScreen} maxWidth="sm" aria-labelledby="choose-rsoc-integration">
            <DialogTitle id="choose-rsoc-integration">Choose RSOC provider
                <SettingsDialogDescription>Connect a provider to synchronize your RSOC revenue.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent sx={{minHeight: 280, position: 'relative'}}>
                {loading && <Spinner overComponentBox noBackShadow/>}
                {requestError && <Alert severity="error" variant="filled" sx={{mb: 2}}>{requestError}</Alert>}
                <TextField variant="outlined" size="small" margin="dense" label="Search providers" name="rsoc"
                    placeholder="Search by provider name" fullWidth slotProps={{inputLabel: {shrink: true}}}
                    value={searchQuery} onChange={handleChange}/>
                {!loading && !requestError && <IntegrationProviderGrid templates={filteredTemps?.filter(item => integrations.includes(item?.name))} onSelect={selectIntegration}/>}
            </DialogContent>
            <DialogActions><Button onClick={handleClose} color="inherit">Cancel</Button></DialogActions>
        </Dialog>
    );
}

export default ChooseRsocIntegration;
